/**
 * POST inquiries to PHP endpoint under /public/api/send-inquiry.php
 * (served as /api/send-inquiry.php from site root after build/deploy).
 */

export function getInquiryApiUrl() {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/api/send-inquiry.php`;
}

/**
 * @param {object} payload
 * @param {string} payload.type - contact | recruitment | quote | general
 * @param {string} payload.email
 * @param {string} payload.message
 * @param {string} [payload._hp] - honeypot, leave empty
 */
export async function sendInquiry(payload) {
  const res = await fetch(getInquiryApiUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ _hp: "", ...payload }),
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const msg = data.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  if (!data.ok) {
    throw new Error(data.error || "Request failed");
  }
  return data;
}
